import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsKnob: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsKnob"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.0188 17 13.967 16.6948 14.7573 16.1715L11.5859 13.0002L13.0002 11.5859L16.1715 14.7573C16.6948 13.967 17 13.0188 17 12C17 9.23858 14.7614 7 12 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsKnob;
